{
  "name": "development",
  "hostname": "localhost",
  "default": null,
  "development": true,
  "production": false,
  "applicationName": "Safari SOP",
  "sourceVersion": "2be74fe89399a6690dec6049be63d8aeaad59693",
  "errors": {
    "numRetries": 0
  },
  "urls": {
    "apiRootCoManage": "https://localhost:5001/",
    "apiRootLpms": "https://localhost:5003/",
    "apiRootSquirrel": "https://api-squirrel-dev.azurewebsites.net/",
    "apiRootRms": "https://localhost:5005/",
    "serveportPortalRoot": "https://localhost:4201/serve/",
    "serveportAgencyPortalUrl": "https://localhost:4201/"
  },
  "auth0": {
    "authorityRoot": "safarilaw-dev.auth0.com",
    "clientId": "oa4BcaqyB0MlVhMdcNDg17Mevv2kA0ai",
    "useLocalStorageCache": true
  },
  "auth": {
    "inactivityTimeout": 15,
    "inactivityWarning": 2
  },
  "featureFlags": {
    "demoPreviews": true,
    "devTools": true,
    "devExceptions": true,
    "enableMatterSubtypePicklistSettingsEditing": true,
    "showMatterSubtypePicklistSettings": true,
    "showCustomPicklistSettings": true,
    "enableCustomPicklistSettingsEditing": true,
    "inputRelativeValidation": true,
    "showServiceAccountSettings": true,
    "notificationBellEnabled": true,
    "enableCloneMatter": true,
    "enableServeportPortalEdit": true,
    "enableServiceOfProcessBusinessHours": true,
    "enableBlackMamba": true,
    "enableFederalBenefitExemptionStatus": true,
    "enableEmailFileViewer": true,
    "enableNonPdfIntakeUpload": true,
    "enablePdfTemplates": true,
    "enableTaskGroups": true
  },
  "stripe": null,
  "loggers": {
    "elmah": {
      "apiKey": "",
      "logId": ""
    },
    "appInsights": {
      "connectionString": ""
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self",
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 20
    },
    "reports": {
      "key": "Z75B-XI571E-733I0T-1L035G-3C1X1G-70694T-6U5216-152R2Z-2Z6Z2A-674A49-4D5J6N"
    },
    "ckeditor": {
      "key": "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE4MjQ1OTUxOTksImp0aSI6ImQ1NWI1Mjc0LTg0YTUtNDZmZC04N2E0LWFlYzZiNmUwOGE3YyIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsic2giLCJkcnVwYWwiXSwid2hpdGVMYWJlbCI6dHJ1ZSwibGljZW5zZVR5cGUiOiJkZXZlbG9wbWVudCIsImZlYXR1cmVzIjpbIkRSVVAiXSwidmMiOiJlOGFlNTQ4NCJ9.oqxsFLsEfR0gmD4JFvTS5TgzpQ4IJ3BwZirvcVT55JzMJxksQcQ8x2UCqNJjtU_ULe3AhCaYNtLrpgJudG_FeQ"
    }
  },
  "bootstrap": {
    "imagesToPreload": [],
    "preloadTimeout": 2500
  },
  "signalR": {
    "hubs": [
      {
        "api": "lpms",
        "name": "matters",
        "url": "signalr/matters"
      },
      {
        "api": "lpms",
        "name": "correspondences",
        "url": "signalr/correspondences"
      },
      {
        "api": "lpms",
        "name": "notifications",
        "url": "signalr/notifications"
      },
      {
        "api": "lpms",
        "name": "intake-files",
        "url": "signalr/intake-files"
      }
    ]
  }
}
